import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { FilterModel } from 'ag-grid-community';
import { NotificationFirestoreService } from '../../services/notification.firestore.service';
import { NotificationActions } from './notification.action';
import { NotificationStateModel } from './notification.store';

@State<NotificationStateModel>({
  name: 'notifications',
  defaults: {
    notifications: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class NotificationState {
  private notificationsService = inject(NotificationFirestoreService);
  // private notificationState = inject(NotificationState);
  // private dbNotification = inject(OrmService).notificationCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(NotificationActions.GetAllNotifications)
  async getAllNotifications(ctx: StateContext<NotificationStateModel>) {
    ctx.patchState({ isLoading: true });
    const notifications = await this.notificationsService.GetAll();
    ctx.patchState({
      notifications: notifications.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(NotificationActions.UpdateNotification)
  async updateNotification(
    ctx: StateContext<NotificationStateModel>,
    { notificationData, ref }: NotificationActions.UpdateNotification,
  ) {
    await this.notificationsService.Update(ref, notificationData);
  }

  @Action(NotificationActions.UpdateNotificationResult)
  updateNotificationResult(
    ctx: StateContext<NotificationStateModel>,
    { data }: NotificationActions.UpdateNotificationResult,
  ) {
    patchState<NotificationStateModel>(ctx, 'notifications', data);
  }

  @Action(NotificationActions.PaginateQueryNotification)
  async queryNotification(
    ctx: StateContext<NotificationStateModel>,
    { request, isResetAfterFilterOrSort }: NotificationActions.PaginateQueryNotification,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['notificationId']) {
    //   (request.filterModel as FilterModel)['notificationId']['values'] = (request.filterModel as FilterModel)[
    //     'notificationId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(NotificationState.notifications).find((notification) => notification.companyName === v)?.ref
    //   );
    // }
    // if (notificationId) {
    //   request.filterModel = {
    //     notificationId: { filter: this.dbNotification.ref(this.dbNotification.id(notificationId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.notificationsService.SetQuery({
      ...request,
      count: state.notifications.length,
      data: state.notifications,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.notifications.length;
      state.notifications = [];
      state.notifications.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.notifications = [];
      state.notifications.length = await this.notificationsService.GetBuildedCount(runs);
    }
    if (state.notifications.length !== 0) {
      runs.push(...this.notificationsService.SetLimit({ ...request, count: state.notifications.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const notifications = await this.notificationsService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        notifications.reverse().forEach(
          ({ data, ref }, i) =>
            (state.notifications[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        notifications.forEach(
          ({ data, ref }, i) =>
            (state.notifications[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, notifications: state.notifications });
  }

  @Action(NotificationActions.NotificationError)
  notificationsError(ctx: StateContext<NotificationStateModel>, { error }: NotificationActions.NotificationError) {
    console.error({ error });
    // await this.notificationsService.Update(id, notificationsData);
  }

  @Action(NotificationActions.DeleteNotifications)
  async deletetnotifications(
    ctx: StateContext<NotificationStateModel>,
    { refs }: NotificationActions.DeleteNotifications,
  ) {
    await this.notificationsService.BatchDelete(refs);
  }

  @Action(NotificationActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<NotificationStateModel>,
    { fields, timePeriod, filterModel }: NotificationActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (notificationId) {
    //   filterModel = { notificationId: { filter: this.dbNotification.ref(this.dbNotification.id(notificationId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.notificationsService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.notificationsService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.notificationsService.QueryCountByCreationDate(
          field.countId,
          field.countValue,
          extraQuerry.runs,
        ),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static notifications(state: NotificationStateModel) {
    return state.notifications;
  }
  @Selector()
  static notificationsCount(state: NotificationStateModel) {
    return state.notifications.length;
  }

  @Selector()
  static sums(state: NotificationStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: NotificationStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static notificationsState(state: NotificationStateModel) {
    return state;
  }
}
